export const snackbar = {
    data() {
        return {
            snackbarTimeout: 3000,
            snackbarY: 'top',
            snackbarX: '',
            snackbarMode: '',
            snackbarShow: false,
            snackbarText: 'Hello',
            snackbarColor: ''
        }
    },
    methods: {
        showSnackbar(text = '', color = '', timeout = 3000) {
            // console.log('Masuk')
            this.snackbarShow = true
            this.snackbarText = text
            this.snackbarColor = color
            this.snackbarTimeout = timeout
        }
    }
}